import { css, StyleSheet } from 'aphrodite';
import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '../../../web/components/Popover';
import { InfoIcon } from '../../../web/components/svgs/icons/InfoIcon';
import { QuestionMarkIcon } from '../../../web/components/svgs/icons/QuestionMarkIcon';
import { brandPrimary, error } from '../../../web/styles/colors';
import { bs } from '../../../web/styles/styles';

interface InfoHoverTagProps {
	message: string;
	variant?: 'default' | 'error';
	side?: 'top' | 'right' | 'bottom' | 'left';
}

export const InfoPopover: React.FC<InfoHoverTagProps> = ({ message, side = 'right', variant = 'default' }) => {
	const [isHovered, setIsHovered] = React.useState(false);

	const handleMouseEnter = () => {
		setIsHovered(true);
	};

	const handleMouseLeave = () => {
		setTimeout(setIsHovered, 200, false);
	};

	return (
		<span>
			<Popover open={isHovered}>
				<PopoverTrigger
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
					className={css(bs.flex, bs.itemsCenter, bs.hFull)}
				>
					{variant === 'default' ? <InfoIcon fillColor={brandPrimary} /> : <QuestionMarkIcon fillColor={error} />}
				</PopoverTrigger>
				<PopoverContent side={side} avoidCollisions className={css(infoPopoverStyles.content)}>
					{message}
				</PopoverContent>
			</Popover>
		</span>
	);
};

const infoPopoverStyles = StyleSheet.create({
	content: {
		maxWidth: 350,
		fontSize: 14,
	},
});
